import React, { createRef, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Button, Input, PaperIcon, Popover } from '@nackle/paper';
import { Search } from '../../shared/icons/icons.js';
import { CloseOutlined, UserOutlined } from '@ant-design/icons';
import { LocaleString, getString } from '@nackle/intl-tools';
import { profileUrl } from 'endpoints';
import { CSSTransition } from 'react-transition-group';
import { getUser } from '../../../app-auth';
import classNames from 'classnames';
import {
    clearSearchedRecipients,
    getPeopleFromNode,
    getPersonDetail,
    removeSelectedPerson,
    searchParticipant,
    selectedRecipientAdd,
    setMyTeam,
} from './actions';

export default function People( props ) {
    const { company, forward, integrationType } = props;
    const dispatch = useDispatch();
    const popupRef = useRef();
    const inputRef = createRef();
    const [ animate, setAnimate ] = useState( false );
    const [ searchValue, setSearchValue ] = useState( '' );
    const myTeam = useSelector( ( state ) => state.people.myTeam || [] );
    const searchedPeople = useSelector(
        ( state ) => state.people.searchedPeople || []
    );
    const selectedPeople = useSelector(
        ( state ) => state.people.selectedPeople || []
    );

    useEffect( () => {
        setAnimate( true );
        window.addEventListener( 'touchstart', handleWindowMouseOrTouch );
        window.addEventListener( 'mousedown', handleWindowMouseOrTouch );
        inputRef.current.focus();
        if ( !myTeam || myTeam.length < 1 ) {
            getTeamMembers();
        }
        return () => {
            window.removeEventListener( 'touchstart', handleWindowMouseOrTouch );
            window.removeEventListener( 'mousedown', handleWindowMouseOrTouch );
        };
    }, [] );

    useEffect( () => {
        const json = JSON.stringify( myTeam );
        const updatedTeamList = JSON.parse( json );
        for ( let i = 0; i < updatedTeamList.length; i++ ) {
            if ( selectedPeople.find( selected => selected.id === updatedTeamList[ i ].id ) ) {
                updatedTeamList[ i ].selected = true;
            }
            else {
                updatedTeamList[ i ].selected = false;
            }
        }
        dispatch( setMyTeam( updatedTeamList ) );
    }, [ selectedPeople ] );

    const getTeamMembers = async () => {
        const nodeId = await dispatch(
            getPersonDetail( ( await getUser() ).claims.person_id )
        );
        dispatch( getPeopleFromNode( nodeId ) );
    };

    const handleInputChange = ( event ) => {
        setSearchValue( event.target.value );
        dispatch( searchParticipant( event.target.value ) );
    };

    const handleWindowMouseOrTouch = ( e ) => {
        if ( popupRef && popupRef.current ) {
            if ( !popupRef.current.contains( e.target ) ) {
                dispatch( clearSearchedRecipients() );
            }
        }
    };
    return (
        <CSSTransition
            timeout={ 1000 }
            in={ animate }
            classNames={ forward ? 'slide-in' : 'slide-out' }
        >
            <div>
                <div data-testid='totalRecipientDiv' style={ { paddingTop: '20px' } }>
                    <LocaleString
                        code="recognition.people.totalRecipients"
                        replaceOptions={ { recipientCount: selectedPeople.length || 0 } }
                    />
                </div>
                <div className="selected-recipients-list">
                    { selectedPeople.map( ( item ) => {
                        return (
                            <div
                                key={ `selected-recipient-${ item.id }` }
                                className="selected-recipient-item"
                                data-testid={ `selected-recipient-${ item.id }` }
                            >
                                <div>
                                    <Avatar
                                        size={ 23 }
                                        className="primary-background-avatar"
                                        src={ `${ profileUrl }/public/images/image/${ company.id }/${ item.id }/avatar` }
                                        icon={
                                            integrationType === 'WORKPLACE' ? <UserOutlined /> : null
                                        }
                                    >
                                        { item.givenName.slice( 0, 1 ) }
                                    </Avatar>
                                </div>
                                <div className="recipient-name">
                                    { `${ item.givenName } ${ item.surname }` }
                                </div>
                                <div className="recipient-remove">
                                    <Button
                                        style={ { border: 0, backgroundColor: 'transparent' } }
                                        size="small"
                                        title={ `${ getString( 'recognition.button.remove' ) } ${ item.givenName
                                            } ${ item.surname }` }
                                        icon={
                                            <CloseOutlined
                                                translate="no"
                                                alt=""
                                                style={ {
                                                    color:
                                                        integrationType === 'WORKPLACE'
                                                            ? '#1a73e8'
                                                            : '#000',
                                                } }
                                            />
                                        }
                                        onClick={ () => dispatch( removeSelectedPerson( item ) ) }
                                    />
                                </div>
                            </div>
                        );
                    } ) }
                </div>
                <div className="search-container">
                    <div className="input-label">
                        <LocaleString code="recognition.people.searchLabel" />
                    </div>
                    <div ref={ popupRef }>
                        <Popover
                            className="search-popover"
                            autoAdjustOverflow={ false }
                            overlayClassName="search-results"
                            placement="bottomLeft"
                            getPopupContainer={ () => popupRef.current }
                            visible={
                                searchedPeople &&
                                    searchedPeople.length > 0 &&
                                    searchValue &&
                                    searchValue.length > 0
                                    ? true
                                    : false
                            }
                            content={
                                searchedPeople &&
                                searchedPeople.map( ( person ) => {
                                    return (
                                        <div
                                            className={ classNames( 'recipient-item', 'clickable' ) }
                                            data-testid={ `searched-item-${ person.id }` }
                                            key={ person.id }
                                            onClick={ () => {
                                                dispatch( selectedRecipientAdd( person ) );
                                                inputRef.current.focus();
                                                setSearchValue( null );
                                            } }
                                        >
                                            <div>
                                                <Avatar
                                                    className="primary-background-avatar"
                                                    src={ `${ profileUrl }/public/images/image/${ company.id }/${ person.id }/avatar` }
                                                    icon={
                                                        integrationType === 'WORKPLACE' ? (
                                                            <UserOutlined />
                                                        ) : null
                                                    }
                                                >{ `${ person.givenName.slice(
                                                    0,
                                                    1
                                                ) }${ person.surname.slice( 0, 1 ) }` }</Avatar>
                                            </div>
                                            <div className="recipient-info">
                                                <div className="recipient-name">
                                                    { `${ person.givenName } ${ person.surname }` }
                                                </div>
                                                { ( person.department || person.jobTitle ) && (
                                                    <div className="recipient-email">
                                                        { `${ person.department ? person.department : '' } ${ person.jobTitle ? person.jobTitle : ''
                                                            }` }
                                                    </div>
                                                ) }
                                                <div className="recipient-email">{ person.country }</div>
                                            </div>
                                        </div>
                                    );
                                } )
                            }
                        >
                            <Input
                                ref={ inputRef }
                                aria-label={ getString( 'recognition.people.searchPlaceholder' ) }
                                bordered={ false }
                                prefix={ <PaperIcon icon={ <Search className="search-icon" /> } /> }
                                size="large"
                                className="search-input"
                                placeholder={ getString( 'recognition.people.searchPlaceholder' ) }
                                value={ searchValue }
                                onChange={ handleInputChange }
                            />
                        </Popover>
                    </div>
                </div>
                <div className="divider" />
                <div className="team-container">
                    <div className="team-select-text">
                        <LocaleString code="recognition.people.addTeamMembers" />
                    </div>
                    { myTeam.map( ( teamRecipient ) => {
                        return teamRecipient.selected ? null : (
                            <div
                                key={ `team-recipient-${ teamRecipient.id }` }
                                className={ classNames( 'recipient-item', 'clickable' ) }
                                onClick={ () => dispatch( selectedRecipientAdd( teamRecipient ) ) }
                                data-testid={ `team-recipient-${ teamRecipient.id }` }
                            >
                                <div>
                                    <Avatar
                                        size={ 42 }
                                        className="primary-background-avatar"
                                        src={ `${ profileUrl }/public/images/image/${ company.id }/${ teamRecipient.id }/avatar` }
                                        icon={
                                            integrationType === 'WORKPLACE' ? <UserOutlined /> : null
                                        }
                                    >{ `${ teamRecipient.givenName.slice(
                                        0,
                                        1
                                    ) }${ teamRecipient.surname.slice( 0, 1 ) }` }</Avatar>
                                </div>
                                <div className="recipient-info">
                                    <div className="recipient-name">
                                        { `${ teamRecipient.givenName } ${ teamRecipient.surname }` }
                                    </div>
                                    { ( teamRecipient.department || teamRecipient.jobTitle ) && (
                                        <div className="recipient-email">
                                            { `${ teamRecipient.department ? teamRecipient.department : ''
                                                } ${ teamRecipient.jobTitle ? teamRecipient.jobTitle : ''
                                                }` }
                                        </div>
                                    ) }
                                    <div className="recipient-email">{ teamRecipient.country }</div>
                                </div>
                            </div>
                        );
                    } ) }
                </div>
            </div>
        </CSSTransition>
    );
}
